/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockItemListCtrl
 */
angular.module('mercury.modules.stock.item')
.controller('StockItemListCtrl', ["dialog", "$filter", "ngToast", "$q", "$scope", "$state", "StockBrands", "StockItemGroups", "StockCost", "StockItems", "StockSuppliers", "StockUnits", "title", "userinfo", "logger", function(dialog, $filter, ngToast, $q, $scope, $state, StockBrands, StockItemGroups,
    StockCost, StockItems, StockSuppliers, StockUnits, title, userinfo, logger) {
  title.set('Manage Stock Items');

  $scope.units = StockUnits.getAllActive();
  $scope.suppliers = StockSuppliers.getAll();
  $scope.itemGroups = StockItemGroups.getAll();
  $scope.allItems = StockItems.getAll();

  $scope.initialLoad = $q.all([
    $scope.allItems.$promise,
    $scope.units.$promise,
    $scope.suppliers.$promise,
    $scope.itemGroups.$promise
  ]);

  $scope.initialLoad.then(function() {
    $scope.filterUpdated();
  });

  $scope.showDeletedItems = false;
  $scope.itemFilter = {name: '', groupId: ''};
  $scope.checkedItems = {};

  $scope.filterUpdated = function() {
    //The default value for angularjs select directives sets the model to null. Change this to an empty string.
    if ($scope.itemFilter.groupId === null) {
      $scope.itemFilter.groupId = '';
    }

    $scope.filteredItems = $filter('filter')($scope.allItems, $scope.itemFilter);

    $scope.filteredItems = $filter('filter')($scope.filteredItems, function(item) {
      return (item.datestampRemoved !== null) == $scope.showDeletedItems;
    });

    $scope.filteredItems = $scope.filteredItems.map(function(item) {
      item.loading = true;
      return item;
    })
  };

  // Used as a callback function for the datatable directive, called with a page worth of items.
  // Will then update the current price information for display.
  $scope.getCurrentPrices = function(pageItems) {
    var itemIds = pageItems.map(function(item) {
      return `${item.id},${moment().format()}`;
    });

    StockCost.get(itemIds, [])
    .then(function(costs) {

      // We walk over all items (all pages worth) and check if the one we're
      // looking at is one we just got cost data for. This is because we only
      // get a page worth of cost data at a time, and it's better to do a single
      // walk over the big list (all items) than to do a walk over the small list
      // but search the big list for the matching item to update each time.
      angular.forEach($scope.filteredItems, function(item) {

        // We only have a page worth of updated items, so check if this item
        // is one we have data for, if not skip it.
        var itemCostData = costs.itemCosts[item.id];
        if (!itemCostData) {
          item.loading = false;
          return;
        }

        // We can assume that the first item in the list is the one to use here,
        // there are other places in Loaded where the StockCost call is made
        // with multiple dates for the same item - in that case there can by more
        // than one item in the list.
        var cost = itemCostData[0];

        // We've got a cost for this item, update the item with that cost and also
        // set a few additional fields that we'll use in the view to know that this
        // is a 'decorated' item.
        if (cost) {
          item.documentType = cost.documentType;
          item.documentId = cost.documentId;
          item.documentNumber = cost.documentNumber;
          item.currentPrice = cost.cost;
          item.loading = false;
        }
      });

    })
    .catch(function(err) {
      logger.info('Failed to get stock cost', err);
      angular.forEach($scope.filteredItems, function(item) {
        item.loading = false;
      });
    });
  };

  $scope.buildTooltipMessage = function(item) {
    return 'From ' + (item.documentType === "PurchaseOrder" ? 'PO#' : '') + item.documentNumber
  }

  $scope.updateField = function(item, field, value) {
    StockItems.patch(item.id, field, value)
    .then(function() {
      ngToast.success(item.name + ' updated.');
    });
  };

  var addIfNotExist = function(object, existingObjects) {
    var updated = false;
    angular.forEach(existingObjects, function(existingObject, index) {
      if (existingObject.id == object.id) {
        // Extend the existing object with the updated fields.
        object = angular.extend(existingObject, object);

        existingObjects.splice(index, 1, object);
        updated = true;
      }
    });

    if (updated === false) {
      existingObjects.push(object);
    }
  };

  $scope.editItem = function(item) {
    var modalInstance = dialog.open({
      templateUrl: 'modules/stock/item/edit.tpl.html',
      controller: 'StockItemEditCtrl',
      size: 'lg',
      resolve: {
        itemId: function() {
          return item.id;
        }
      }
    });

    modalInstance.then(function(updatedItem) {
      //If this item is taking it's stock cost from the global price, make sure it is up to date.
      updatedItem.currentPricePurchaseOrderOrderNumber = item.currentPricePurchaseOrderOrderNumber;
      updatedItem.currentPrice = item.currentPricePurchaseOrderOrderNumber ? item.currentPrice : updatedItem.globalPrice;

      addIfNotExist(updatedItem, $scope.allItems);

      $scope.filterUpdated();
    });
  };

  $scope.addItem = function() {
    dialog.open({
      templateUrl: 'modules/stock/item/add.tpl.html',
      controller: 'StockItemAddCtrl',
      size: 'lg'
    }).then(function(addResult) {
      addResult.currentPrice = addResult.globalPrice;

      addIfNotExist(addResult.item, $scope.allItems);

      if (addResult.orderingUnit) {
        addIfNotExist(addResult.orderingUnit, $scope.units);
      }

      if (addResult.countingUnit) {
        addIfNotExist(addResult.countingUnit, $scope.units);
      }

      if (addResult.defaultSupplier) {
        addIfNotExist(addResult.defaultSupplier, $scope.suppliers);
      }

      if (addResult.itemGroup) {
        addIfNotExist(addResult.itemGroup, $scope.itemGroups);
      }

      $scope.filterUpdated();
    });
  };

  /**
  * Callback for Delete Item action. Will display an error message is attempted on a shared item.
  */
  $scope.deleteItem = function(item) {
    if (item.isShared && !userinfo.companyHasPermission('StockShare')) {
      dialog.alert('This item has been shared with other companies and cannot be deleted without \'Stock Sharing\' permission.');
    } else {
      StockItems.remove(item)
      .then(function() {
        item.datestampRemoved = moment().format();
        $scope.filterUpdated();
      });
    }
  };

  $scope.undeleteItem = function(item) {
    StockItems.restore(item)
    .then(function() {
      item.datestampRemoved = null;
      $scope.filterUpdated();
    });
  };

  $scope.orderingUnitMore = function(item) {
    dialog.open({
      controller: 'StockUnitPopupCtrl',
      templateUrl: 'modules/stock/unit/popup.tpl.html',
      resolve: {
        onAdd: function() {
          return function(newUnit) {
            $scope.units.push(newUnit);
          };
        }
      }
    }).then(function(result) {
      item.orderingUnitId = result.id;
      item.orderingUnitName = result.name;
      item.orderingUnitRatio = result.ratio;

      $scope.updateField(item, 'orderingUnitId');
    });
  };

  $scope.countingUnitMore = function(item) {
    dialog.open({
      controller: 'StockUnitPopupCtrl',
      templateUrl: 'modules/stock/unit/popup.tpl.html',
      resolve: {
        onAdd: function() {
          return function(newUnit) {
            $scope.units.push(newUnit);
          };
        }
      }
    }).then(function(result) {
      item.countingUnitId = result.id;
      item.countingUnitName = result.name;

      $scope.updateField(item, 'countingUnitId');
    });
  };

  $scope.defaultSupplierMore = function(item) {
    dialog.open({
      controller: 'StockSupplierPopupCtrl',
      templateUrl: 'modules/stock/supplier/popup.tpl.html',
      size: 'lg',
      resolve: {
        onAdd: function() {
          return function(newSupplier) {
            $scope.suppliers.push(newSupplier);
          };
        }
      }
    }).then(function(result) {
      item.defaultSupplierId = result.id;
      item.defaultSupplierName = result.name;

      $scope.updateField(item, 'defaultSupplierId');
    });
  };

  $scope.shareItem = function(item) {
    dialog.open({
      templateUrl: 'modules/stock/item/share.tpl.html',
      controller: 'StockItemShareCtrl',
      resolve: {
        itemIds: function() {
          return [item.id];
        },
        companyId: function() {
          return null;
        }
      }
    });
  };

  $scope.manageShare = function(item) {
    dialog.open({
      templateUrl: 'modules/stock/item/manageshare.tpl.html',
      controller: 'StockItemManageShareCtrl',
      size: 'lg',
      resolve: {
        itemId: function() {
          return item.id;
        }
      }
    });
  };

  /*
   * Event called when an item from the current company is updated from the manage share dialog.
   */
  $scope.$on('manageSharedItemUpdated', function(event, updatedItem) {
    angular.forEach($scope.allItems, function(item) {
      if (item.id == updatedItem.id) {
        item = angular.extend(item, updatedItem);

        if (!item.currentPricePurchaseOrderOrderNumber) {
          item.currentPrice = item.globalPrice;
        }

        if (item.datestampRemoved) {
          $scope.filterUpdated();
        }
      }
    });
  });

  $scope.checkAll = function(state) {
    $scope.checkedItems = {};
    angular.forEach($scope.allItems, function(item) {
      if (!item.datestampRemoved) {
        $scope.checkedItems[item.id] = state;
      }
    });
  };

  $scope.cancelShare = function() {
    $scope.shareMode = false;
    $scope.checkedItems = {};
  };

  var bulkShare = function(itemIds) {
    dialog.open({
      templateUrl: 'modules/stock/item/share.tpl.html',
      controller: 'StockItemShareCtrl',
      resolve: {
        itemIds: function() {
          return itemIds;
        },
        companyId: function() {
          return null;
        }
      }
    });
  };

  $scope.shareSelected = function() {
    var selectedItems = [];
    angular.forEach($scope.checkedItems, function(isChecked, itemId) {
      if (isChecked) {
        selectedItems.push(itemId);
      }
    });

    if (selectedItems.length === 0) {
      dialog.alert('Please select items to share using the checkboxes beside the item names.');
      return;
    }

    bulkShare(selectedItems);

    $scope.cancelShare();
  };

  $scope.shareAll = function() {
    var itemIds = [];
    angular.forEach($scope.allItems, function(item) {
      if (!item.datestampRemoved) {
        itemIds.push(item.id);
      }
    });

    bulkShare(itemIds);

    $scope.cancelShare();
  };

  $scope.viewStockCost = function(item) {
    $state.go('.StockPrice',
    {itemId: item.id, quantity: 1, unitRatio: item.orderingUnitRatio, unitName: item.orderingUnitName},
    {location: 'replace'});
  };
}]);
